// extracted by mini-css-extract-plugin
module.exports = {"explanationField":"ChecklistQuestionFormItem_explanationField__2sVwb"};